import { from } from 'rxjs';
import { map } from 'rxjs/operators';

import { resolveRestApi } from '../../router/app-router';
import { fetch } from '../../service_broker/fetch';
import * as actionType from '../../store/state/actions';
import { logAndCatchError } from '../../utils/rxjs-utils';
import { processHeaders } from '../../store/state/epics/util';

const DXAPI_ERROR = 'Error occurred during ajax call at getDataObjectView Epic';

const executeGetDataObjectViewRequest = (actionInPayload: any) => {
  const { dataLookUp, context, headers, viewName, requestPayload } = actionInPayload;

  const requestPayloadAPI = {
    data_view_ID: dataLookUp,
    view_ID: viewName
  };

  const { restApi, reqType } = resolveRestApi(actionType.ACTION_GET_DATA_OBJECT_VIEW, requestPayloadAPI);

  return from(
    fetch(
      restApi,
      {
        method: reqType,
        headers,
        body: {
          dataViewParameters: requestPayload
        }
      },
      context
    )
  ).pipe(
    map((response: any) => {
      return {
        response: response.data,
        headers: processHeaders(response.headers),
        actionInPayload
      };
    }),
    logAndCatchError(DXAPI_ERROR, context)
  );
};

export default executeGetDataObjectViewRequest;
